import React, { useEffect, useId, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import './review-documents.css';

export default function ReviewDocument({ question, reviewToken }) {
  const [url, setUrl] = useState('');
  const [message, setMessage] = useState('Chargement du document…');
  const [open, setOpen] = useState(false);
  const [zoom, setZoom] = useState(1);
  const dialogRef = useRef(null);
  const titleId = useId();
  useEffect(() => {
    const controller = new AbortController();
    let objectUrl;
    setUrl(''); setOpen(false);
    setMessage('Chargement du document…');
    fetch(`/backend/salesforce/candidature/review/documents/${encodeURIComponent(`${question.nom}.png`)}`, {
      headers: { 'x-review-token': reviewToken }, cache: 'no-store', signal: controller.signal
    }).then(async response => {
      if (!response.ok) {
        const result = await response.json().catch(() => ({}));
        throw new Error(result.message || 'Document indisponible.');
      }
      const blob = await response.blob();
      if (controller.signal.aborted) return;
      objectUrl = URL.createObjectURL(blob);
      setUrl(objectUrl);
    }).catch(error => { if (!controller.signal.aborted) setMessage(error.message); });
    return () => { controller.abort(); if (objectUrl) URL.revokeObjectURL(objectUrl); };
  }, [question.nom, reviewToken]);

  useEffect(() => {
    if (!open) return undefined;
    const dialog = dialogRef.current;
    const overflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    dialog.showModal();
    return () => { dialog.close(); document.body.style.overflow = overflow; };
  }, [open]);

  const enlarge = event => { event.preventDefault(); setZoom(1); setOpen(true); };
  return <div className="question">
    <label className="questionTitle">{question.etiquette}</label>
    {url ? <div className="uploadContainer">
      <a href={url} onClick={enlarge} className="review-document-preview" aria-label={`Agrandir : ${question.etiquette || 'Document du dossier'}`}>
        <img src={url} alt={question.etiquette || 'Document du dossier'} style={{ maxWidth: '100%' }} />
      </a>
      <a href={url} onClick={enlarge}>Agrandir le document</a>
    </div> : <p role="status">{message}</p>}
    {/* Le portail sort la fenêtre du fieldset en lecture seule : les commandes restent actives. */}
    {open && createPortal(<dialog ref={dialogRef} className="review-document-dialog" aria-labelledby={titleId}
      onCancel={() => setOpen(false)} onClose={() => { if (!dialogRef.current?.open) setOpen(false); }}
      onClick={event => { if (event.target === event.currentTarget) setOpen(false); }}>
      <div className="review-document-dialog__content">
        <header>
          <h2 id={titleId}>{question.etiquette || 'Document du dossier'}</h2>
          <div className="review-document-dialog__controls">
            <button type="button" onClick={() => setZoom(value => Math.max(1, value - 0.5))} disabled={zoom === 1} aria-label="Réduire">−</button>
            <button type="button" onClick={() => setZoom(1)}>Ajuster</button>
            <button type="button" onClick={() => setZoom(value => Math.min(3, value + 0.5))} disabled={zoom === 3} aria-label="Agrandir">+</button>
            <button type="button" autoFocus onClick={() => setOpen(false)}>Fermer</button>
          </div>
        </header>
        <div className="review-document-dialog__image">
          <img src={url} alt={question.etiquette || 'Document du dossier'}
            style={zoom > 1 ? { width: `${zoom * 100}%`, maxWidth: 'none', maxHeight: 'none' } : undefined} />
        </div>
      </div>
    </dialog>, document.body)}
  </div>;
}
